import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SpinBoxDirective } from './spin-box.directive';

@NgModule({
    declarations: [
        SpinBoxDirective,
    ],
    imports: [
        CommonModule,
    ],
    exports: [
        SpinBoxDirective,
    ]
})
export class NgSpinBoxModule { }
